import { Injectable } from '@angular/core';
import { UserSessionService } from '@com-delta-idp/mnx-oauth';
import { UserSessionService as SitewideUserSessionService } from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Action, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, filter, map, switchMap } from 'rxjs/operators';
import { BOOK_WIDGET_ERROR_CODES } from '../../constants/error-codes.constants';
import { FlightShopWidgetTemplates } from '../../constants/flight-shop.constants';
import { DashboardResponse } from '../../models/login-dashboard.interfaces';
import * as fromErrorHandlerActions from '../actions/error-handler.actions';
import * as fromLoginDashboardActions from '../actions/login-dashboard.actions';
import { getFlightShopTemplateType } from '../selectors/book-widget.selectors';
import { shouldTriggerLoginDashboardApi } from '../selectors/login-dashboard.selectors';

@Injectable({ providedIn: 'root' })
export class LoginDashboardEffects {
  LoadDashboardLanding$ = createEffect(
    (): Observable<Action> =>
      this.Actions$.pipe(
        ofType(fromLoginDashboardActions.LoadDashboardLanding),
        concatLatestFrom(() => [
          this.store.select(shouldTriggerLoginDashboardApi),
          this.store.select(getFlightShopTemplateType)
        ]),
        filter(
          ([, shouldTriggerLoginDashboardApiValue]) =>
            shouldTriggerLoginDashboardApiValue
        ),
        switchMap(([, , flightShopWidgetTemplate]) => {
          const service =
            flightShopWidgetTemplate === FlightShopWidgetTemplates.HOME
              ? this.sitewideUserSessionService
              : this.userSession;

          return service.getUserSession().pipe(
            map((dashboardResponse: DashboardResponse) =>
              fromLoginDashboardActions.LoadDashboardLandingSuccess({
                dashboardResponse
              })
            ),
            catchError(() => {
              return of(
                fromErrorHandlerActions.HandleError({
                  errorCode: BOOK_WIDGET_ERROR_CODES.LOGIN_DASHBOARD_FAILURE,
                  error: BOOK_WIDGET_ERROR_CODES.LOGIN_DASHBOARD_FAILURE
                }),
                fromLoginDashboardActions.LoadDashboardLandingFailure()
              );
            })
          );
        })
      )
  );

  constructor(
    private Actions$: Actions,
    private userSession: UserSessionService,
    private sitewideUserSessionService: SitewideUserSessionService,
    private store: Store
  ) {}
}
